export const generateGetItemsByIdsQueryVariables = (
	sourceAri: string,
	ids: string[],
	isRoadmapsCriticalDataItemFlaggedEnabled: boolean,
) => ({
	sourceAri,
	ids,
	isRoadmapsCriticalDataItemFlaggedEnabled,
});
